import React from "react";

import {
  MdInfo,
  MdReportProblem,
  MdCheckCircle,
  MdError,
  MdNotifications,
} from "react-icons/md";

export enum AlertInterface {
  success = "success",
  danger = "danger",
  info = "info",
  warning = "warning",
  secondary = "secondary",
}

interface AlertProps {
  title: string;
  description?: string;
  theme: AlertInterface;
}
const Alert = ({ title, description, theme }: AlertProps): JSX.Element => {
  let Icon: any;

  if (theme === AlertInterface.danger) {
    Icon = MdReportProblem;
  } else if (theme === AlertInterface.info) {
    Icon = MdInfo;
  } else if (theme === AlertInterface.success) {
    Icon = MdCheckCircle;
  } else if (theme === AlertInterface.warning) {
    Icon = MdError;
  } else {
    Icon = MdNotifications;
  }

  return (
    <div
      className={`alert-${theme} mb-3 animate__animated animate_zoomIn animate__faster`}
      role="alert"
    >
      <div className="flex">
        <div className="py-1">
          <Icon className="fill-current h-6 w-6 text-green-500- opacity-60 mr-4" />
        </div>
        <div>
          <p className="font-bold">{!title ? "Alert" : title}</p>
          {!description ? null : <p className="text-sm">{description}</p>}
        </div>
      </div>
    </div>
  );
};

export default Alert;
